import axios from '@axios'
import jwt from '@/auth/jwt/useJwt'

export default {
  login() {
    return new Promise((resolve, reject) => {
      axios.post('/auth/scienceid/login/', { redirect_url: `${window.location.origin}/science-id` }, { skipAuth: true })
        .then(response => {
          window.location.href = response.data.login_url
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-unused-vars
  async confirm({ commit }, query) {
    let response = await axios.post('/auth/scienceid/confirm/', { code: query.code }, { skipAuth: true })
    response = await jwt.setAll(response.data)
    return response
  },
}
